/*
 * Decorative gradients, verbatim from the design. They are deliberately plain strings: a stop
 * moved by a few percent or an alpha nudged by 0.05 already differs from Figma, so they are
 * copied and read as a whole — never assembled from primitives, alpha() calls or loops.
 * Edit by pasting the new value from Figma; each stop sits on its own line for diffing.
 */

export const gradients = {
  heroGlow: `radial-gradient(
    130% 90% at 25% -10%,
    rgb(92, 206, 255, 0.72) 16%,
    rgb(99, 120, 253, 0.45) 62%,
    rgb(85, 62, 255, 0) 95%
  )`,
  avatarGlow: `radial-gradient(
    circle closest-side,
    rgb(122, 177, 255, 0) 69%,
    rgb(131, 169, 255, 0.06) 72%,
    rgb(28, 233, 252, 0.22) 77%,
    rgb(28, 233, 252, 0.48) 85%,
    rgb(28, 233, 252, 0.83) 95%,
    rgb(28, 233, 252, 0.86) 96%
  )`,
  zodiacWheelGlow: `radial-gradient(
    circle closest-side,
    rgb(42 255 204 / 0) 57%,
    rgb(42 255 204 / 0.1) 73%,
    rgb(42 255 204 / 0.2) 81.5%,
    rgb(42 255 204 / 0.4) 91%,
    rgb(42 255 204 / 0.6) 96%,
    rgb(42 255 204 / 0.8) 99%,
    rgb(42 255 204 / 1) 100%
  )`,
  zodiacWheelBeam: `linear-gradient(
    180deg,
    rgb(42 255 204 / 0) 0%,
    rgb(42 255 204 / 0.15) 50%,
    rgb(42 255 204 / 0.35) 100%
  )`,
  w2aStepsRail: `linear-gradient(
    180deg,
    rgba(52, 225, 225, 0.7) 0%,
    rgba(50, 164, 218, 0.5) 25%,
    rgba(49, 103, 210, 0.3) 50%,
    rgba(49, 103, 210, 0) 100%
  )`,
  upsellsBanner: `radial-gradient(
    ellipse 45% 135% at 50% -36%,
    #FF8577 0%,
    #CC6C96 50%,
    #9852B4 100%
  )`,
  specialOfferCard: `radial-gradient(
    100% 85% at 50% 0%,
    #306DA0 0%,
    #2C3C82 62.5%,
    #27315C 79%,
    #212535 95%
  )`,
  askOnboardingGlows: [
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(196, 0, 90, 0.7) 16%,
      rgba(151, 0, 69, 0.6) 39%,
      rgba(107, 0, 49, 0.5) 63%,
      rgba(82, 16, 46, 0) 95%
    )`,
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(210, 98, 255, 0.7) 16%,
      rgba(165, 67, 204, 0.6) 39%,
      rgba(120, 36, 153, 0.5) 63%,
      rgba(75, 13, 97, 0) 95%
    )`,
    `radial-gradient(
      ellipse 310px 285px at 50% 43%,
      rgba(47, 169, 221, 0.7) 16%,
      rgba(53, 125, 223, 0.6) 39%,
      rgba(58, 81, 224, 0.5) 63%,
      rgba(77, 66, 160, 0) 95%
    )`,
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(79, 252, 168, 0.6) 16%,
      rgba(53, 169, 125, 0.55) 39%,
      rgba(40, 128, 103, 0.53) 51%,
      rgba(27, 87, 82, 0.5) 63%,
      rgba(6, 28, 53, 0) 95%
    )`,
  ],
  specialOfferCardLight: `radial-gradient(
    155% 120% at 50% -44%,
    rgba(220, 125, 0, 0.5) 16%,
    rgba(236, 98, 0, 0.2) 46%,
    rgba(194, 74, 0, 0) 100%
  ), #FFFFEF`,
  // The light ribbon is a raster fill in Figma; the stops are sampled from that asset (top / middle / bottom).
  specialOfferRibbonLight: `linear-gradient(
    180deg,
    #6F103B 0%,
    #A12D3B 50%,
    #C66037 100%
  )`,
  zodiacWheelGlowLight: `radial-gradient(
    circle closest-side,
    rgba(99, 120, 253, 0) 63%,
    rgba(99, 120, 253, 0.5) 90%,
    rgba(99, 120, 253, 1) 100%
  )`,
  askOnboardingGlowsLight: [
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(255, 133, 119, 0.72) 16%,
      rgba(227, 227, 211, 0) 95%
    )`,
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(210, 98, 255, 0.54) 16%,
      rgba(227, 171, 243, 0.27) 56%,
      rgba(244, 244, 230, 0) 95%
    )`,
    `radial-gradient(
      ellipse 310px 285px at 50% 43%,
      rgba(47, 169, 221, 0.63) 16%,
      rgba(96, 188, 223, 0.47) 36%,
      rgba(146, 206, 226, 0.32) 56%,
      rgba(244, 244, 230, 0) 95%
    )`,
    `radial-gradient(
      ellipse 290px 300px at 50% 44%,
      rgba(84, 217, 147, 0.63) 16%,
      rgba(164, 231, 189, 0.32) 56%,
      rgba(244, 244, 230, 0) 95%
    )`,
  ],
};
